import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { ImagesFeed, Feed, Image } from '@bepure/tarkin';

// declare const BASE_API_URL: string;

enum InstaAccount {
    EVE = 'EVE',
    BEPURE = 'BEPURE',
}

interface InstagramFeedProps {
    feed: Feed;
    account: InstaAccount;
}

interface InstagramFeedState {
    images: Image[];
}

class InstagramFeed extends React.PureComponent<InstagramFeedProps, InstagramFeedState> {
    constructor(props: any) {
        super(props);

        this.state = {
            images: [],
        };
    }

    public componentDidMount() {
        this.loadImages();
    }
    public render() {
        return (
            <ImagesFeed images={this.state.images} feed={this.props.feed} />
        );
    }

    private loadImages = async (): Promise<void> => {
        const eveInstagramMediaURL = 'https://www.instagram.com/evewellnessco_/?__a=1';
        if (this.props.account === InstaAccount.EVE) {
            try {
                const response = await fetch(eveInstagramMediaURL, {
                    method: 'GET',
                }).then(data => {
                    return data.json();
                });
                const edges = response.graphql.user.edge_owner_to_timeline_media.edges;
                const imageData: any[] = [];
                edges.forEach((edge: any) => imageData.push({id: edge.node.id, url: edge.node.thumbnail_src}));
                if (response) {
                    await this.setState({
                        images: imageData,
                    });
                } else {
                    document.getElementById('instagram-feed-eve')!.style.display = 'none';
                }
            } catch (error) {
                document.getElementById('instagram-feed-eve')!.style.display = 'none';
            }
        }
    }
}

export function renderEve() {
    const elements = document.getElementsByClassName('instagram-feed-eve');
    Array.prototype.map.call(elements, (element: HTMLElement) => {
        const feed = element.dataset.feed ? JSON.parse(element.dataset.feed) : {};

        return ReactDOM.render(
            <InstagramFeed feed={feed} account={InstaAccount.EVE}/>,
            element,
        );
    });
}

export function renderBePure() {
    const elements = document.getElementsByClassName('instagram-feed-bepure');
    Array.prototype.map.call(elements, (element: HTMLElement) => {
        const feed = element.dataset.feed ? JSON.parse(element.dataset.feed) : {};

        return ReactDOM.render(
            <InstagramFeed feed={feed} account={InstaAccount.BEPURE}/>,
            element,
        );
    });
}
